import { Outlet } from 'react-router-dom';

function New() {
  return <Outlet />;
}

export default New;
